import GeoEdge from 'components/GeoEdge';
import Prebid from 'components/Prebid';
import AmazonTam from 'components/AmazonTam';
import BaseAd from 'oxygen-lib-ui/components/Ad';

// Custom refresh function that calls the correct refresh logic for the slot
export function refresh(slots, options = { changeCorrelator: false }) {
  // Note, `this` is bound to the `googletag` object
  // Use the supplied `slot`, or if not set get all the slots on the page to mimic
  // an empty call to `pubads().refresh` which will refresh all slots.
  const ads = (slots || this.pubads().getSlots()).reduce(
    (p, slot) => {
      const id = slot.getSlotElementId();
      // CLEANUP: Move to Ad.hasSizeForViewport!
      if (Prebid.isPbjsAd(id) && Prebid.hasSizeForViewport(id)) {
        // This slot is configured for header bidding
        p.hb.push(slot);
      } else {
        // Ad Man
        p.gpt.push(slot);
      }
      return p;
    },
    { hb: [], gpt: [] }
  );

  // Header bidding slots
  if (ads.hb.length) {
    // Fetch Prebid and TAM bids
    const bids = [
      Prebid.fetchBannerBids(ads.hb),
      AmazonTam.fetchBannerBids(ads.hb)
    ];
    Promise.all(bids).then(() => {
      // Refresh slots after bids are returned
      this.pubads().refresh(ads.hb, options);
    });
  }

  // Slots without header bidding
  if (ads.gpt.length) {
    // Refresh the slots without any header bidding
    this.pubads().refresh(ads.gpt, options);
  }
}

// Use custom refresh function
BaseAd.configure({ refresh });

// Use SRA
BaseAd.enableSingleRequest();

// Disable initial load so we can call refresh when Prebid and GeoEdge are ready
BaseAd.disableInitialLoad();

// Called once when the FIRST ad renders
BaseAd.onRender(() => {
  // Init Prebid and TAM before calling refresh
  Promise.all([Prebid.init(), AmazonTam.init()]).then(() => {
    // Wait for GeoEdge to load before calling refresh
    GeoEdge.onReady(BaseAd.refresh);
  });
});

export default function AdMan() {
  return null;
}
